import PageHeader from "components/PageHeader/PageHeader";
import { FC, useEffect, useState } from "react";
import { getProjects } from "data/api";
import { ProjectDataType } from "data/types";
import { Helmet } from "react-helmet-async";
import SectionProjectsGrid from "./SectionProjectsGrid";

export interface ProjectsPageProps {
  className?: string;
}

const ProjectsPage: FC<ProjectsPageProps> = ({ className = "" }) => {
  const [projects, setProjects] = useState<ProjectDataType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getProjects()
      .then((items) => {
        if (!Array.isArray(items)) {
          setProjects([]);
          return;
        }
        setProjects(
          items.map((item: any) => ({
            id: item.id,
            name: item.name,
            description: item.description || "",
            images: item.images,
            date: item.date || "",
            url: item.url || "",
          }))
        );
      })
      .catch(() => setError("Failed to load projects. Please try again."))
      .finally(() => setLoading(false));
  }, []);

  if (error) {
    return (
      <div className="container py-24 text-center">
        <p className="text-red-500 mb-4">{error}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="bcr-btn-primary text-sm"
        >
          Try again
        </button>
      </div>
    );
  }

  return (
    <div
      className={`nc-ListingExperiencesPage relative overflow-hidden ${className}`}
      data-nc-id="ListingExperiencesPage"
    >
      <Helmet>
        <title>Our Projects | BCR LTD. UK</title>
        <meta
          name="description"
          content="Explore landmark construction projects across the UAE and GCC where BCR Ltd supplied expansion joint covers, tile trims, shadow gap profiles, and premium building solutions."
        />
      </Helmet>

      <PageHeader
        title="Our Projects"
        subtitle="Discover the projects we've proudly contributed to over 50 years of building excellence across the Middle East."
      />

      <div className="container relative px-4 sm:px-6 pb-16 sm:pb-20 pt-6 sm:pt-8">
        <SectionProjectsGrid projects={projects} isLoading={loading} />
      </div>
    </div>
  );
};

export default ProjectsPage;
